/* Pikemla — free-shipping progress system.
 * Paints every [data-pk-ship-progress] bar from /cart.js and keeps it live:
 * listens for the theme's `cart:update` event and for cart-drawer opens.
 * Drawer add-on suggestions are one-tap: POST to /cart/add.js, then dispatch
 * `cart:update` so the theme re-renders the drawer with the new line item.
 */
(function () {
  'use strict';

  var DEFAULT_THRESHOLD = 6500; // $65 free-shipping threshold, in cents

  // Real, active, in-stock add-on products (cheap, broad appeal). The first
  // available variant is chosen at runtime; fallbackVariant is a safety net.
  var ADDONS = [
    { handle: 'strapless-adhesive-bra-invisible-backless', fallbackVariant: 45227059445954 },
    { handle: 'wh2wic-1848-id-wh2001996', fallbackVariant: 45188176380098 },
    { handle: 'wh2cla-bt5610-id-wh200249520', fallbackVariant: 45495347511490 },
    { handle: 'wh2hda-bdba375-id-wh2250138', fallbackVariant: 45979105165506 },
  ];

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function setBar(el, totalCents) {
    var threshold = parseInt(el.getAttribute('data-threshold') || DEFAULT_THRESHOLD, 10);
    var remaining = Math.max(0, threshold - totalCents);
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));

    var fill = el.querySelector('[data-pk-ship-fill]');
    var track = el.querySelector('[data-pk-ship-track]');
    var msg = el.querySelector('[data-pk-ship-msg]');
    if (!fill || !track || !msg) return;

    fill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', String(Math.min(totalCents, threshold)));

    if (remaining > 0) {
      msg.innerHTML =
        "You're <strong>" + money(remaining) + '</strong> away from <strong>FREE shipping</strong>';
    } else {
      msg.innerHTML = '<strong>You&rsquo;ve unlocked FREE shipping</strong> — nice one.';
    }

    var addons = el.querySelector('[data-pk-ship-addons]');
    if (addons) {
      addons.hidden = remaining <= 0;
    }
  }

  function paintAll(totalCents) {
    document.querySelectorAll('[data-pk-ship-progress]').forEach(function (el) {
      setBar(el, totalCents);
    });
  }

  var refreshTimer = null;
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintAll(cart.total_price || 0);
        ensureAddonsLoaded();
      })
      .catch(function () {});
  }
  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, typeof delay === 'number' ? delay : 150);
  }

  /* ---------- add-on suggestions ---------- */

  function variantIdFor(product) {
    if (product && product.variants && product.variants.length) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i].id;
      }
    }
    return null;
  }

  function addonCard(product, def) {
    var vid = variantIdFor(product) || def.fallbackVariant;
    var img = product.featured_image
      ? '<img class="pk-ship-addon__img" src="' + product.featured_image + '" alt="" loading="lazy">'
      : '';
    return (
      '<div class="pk-ship-addon">' +
      img +
      '<div class="pk-ship-addon__info">' +
      '<p class="pk-ship-addon__title">' + escapeHtml(product.title) + '</p>' +
      '<p class="pk-ship-addon__price">' + money(product.price) + '</p>' +
      '<button type="button" class="pk-ship-addon__add" data-pk-addon-add="' + vid + '">Add</button>' +
      '</div></div>'
    );
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var addonsLoaded = false;
  function ensureAddonsLoaded() {
    if (addonsLoaded) return;
    var grids = document.querySelectorAll('[data-pk-ship-addons-grid]:not([data-pk-loaded])');
    if (!grids.length) return;
    addonsLoaded = true;
    grids.forEach(function (grid) {
      grid.setAttribute('data-pk-loaded', '1');
      grid.innerHTML = '<p class="pk-ship-addons__loading">Finding little extras&hellip;</p>';
      Promise.all(
        ADDONS.map(function (def) {
          return fetch('/products/' + def.handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { return p ? addonCard(p, def) : ''; })
            .catch(function () { return ''; });
        })
      ).then(function (cards) {
        var html = cards.join('');
        document.querySelectorAll('[data-pk-ship-addons-grid][data-pk-loaded]').forEach(function (g) {
          g.innerHTML = html || '';
        });
      });
    });
  }

  // One-tap add: event delegation survives drawer re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pk-addon-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-pk-addon-add'), 10), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        // Tell the theme the cart changed: cart-items-component re-renders
        // the drawer section from the server (new line item included).
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {} }));
        scheduleRefresh(400);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = original;
        }, 1200);
      });
  });

  /* ---------- wiring ---------- */

  // Immediate paint from server-rendered value (no flash of empty bar).
  document.querySelectorAll('[data-pk-ship-progress]').forEach(function (el) {
    var initial = parseInt(el.getAttribute('data-initial-cents') || '0', 10);
    setBar(el, isNaN(initial) ? 0 : initial);
  });

  // Authoritative state from the cart API.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Theme fires `cart:update` on add-to-cart, quick-add, quantity changes,
  // and discount changes — refresh the bars on all of them.
  document.addEventListener('cart:update', function () {
    scheduleRefresh(300);
  });

  // Refresh when the drawer opens (drawer content may be server-stale).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-testid="cart-drawer-trigger"]')) {
      scheduleRefresh(500);
    }
  });
})();
